import React from "react";
import { Row } from "antd";
import presentation from "assets/images/frontPageModulesImages/presentationAuditorium.png";
import jobPostings from "assets/images/frontPageModulesImages/jobPostings.png";
import casebank from "assets/images/frontPageModulesImages/casebank.png";
import useViewport from "components/UseViewport/UseViewport";
import FrontPageModule from "./FrontPageModule/FrontpageModule";

const OfferingsSection: React.FC = () => {
  const { width } = useViewport();
  const breakpoint = 750;
  return (
    <Row style={{ padding: width < breakpoint ? "0em 0em" : "0em 9em" }}>
      <FrontPageModule
        imageLink={presentation}
        imageAlt="Presentation auditorium"
        title="Bedriftspresentasjoner"
        text="Bindeleddet arrangerer, i samarbeid med en rekke bedrifter fra ulike bransjer, bedriftspresentasjoner hvert år for at studenter skal kunne lære mer om potensielle fremtidige arbeidsgivere"
        positionLeft
        urlLink="/events/"
      />
      <FrontPageModule
        imageLink={jobPostings}
        imageAlt="job postings presentation auditorium"
        title="Stillingsannonser"
        text=" Bedrifter legger daglig ut nye stillingsannonser for ulike jobber på våre sider. Det er stor mulighet for at du finner din drømmejobb her "
        positionLeft={false}
        urlLink="/jobs/"
      />
      <FrontPageModule
        imageLink={casebank}
        imageAlt="casebank"
        title="Casebank"
        text="For å gjøre jobbsøkerprosessen enklere har vi laget en casebank der vi samler inn case fra bedrifter som studenter kan prøve seg på"
        positionLeft
        urlLink="/casebank/"
      />
    </Row>
  );
};

export default OfferingsSection;
